module.exports = __webpack_public_path__ + "static/partners-mobile-2432511f3797d7357a5501f9d961bdea.svg";